import { render, staticRenderFns } from "./SystemTagManagementSingle.vue?vue&type=template&id=5d0e2a3a"
import script from "./SystemTagManagementSingle.vue?vue&type=script&lang=js"
export * from "./SystemTagManagementSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports